import React from 'react';

export const Retake:React.FC = () => (
  <svg
    id="back-arrow"
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="currentColor"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 7.89727C15.4981 9.72592 14.8062 11.4791 13.576 12.7722C12.3459 14.0652 10.678 14.7925 8.9383 14.7945H5.46994L8.62912 18.1138L7.786 19L3.18967 14.1671L7.78457 9.3342L8.62768 10.2204L5.46994 13.5412H8.94546C9.66081 13.5585 10.3723 13.4254 11.038 13.1497C11.7037 12.8739 12.3103 12.4611 12.822 11.9354C13.3338 11.4098 13.7405 10.7819 14.0181 10.0887C14.2957 9.39545 14.4387 8.65091 14.4387 7.89877C14.4387 7.14664 14.2957 6.40209 14.0181 5.70888C13.7405 5.01567 13.3338 4.38778 12.822 3.86212C12.3103 3.33646 11.7037 2.92362 11.038 2.64786C10.3723 2.37211 9.66081 2.23901 8.94546 2.25637H0.5V1H8.94546C10.6839 1.00398 12.35 1.73217 13.5786 3.02501C14.8072 4.31786 15.4981 6.06991 15.5 7.89727Z"
      strokeWidth="0.5"
    />
  </svg>
);
